class OrderStatusModel
{
    constructor(obj?: OrderStatusModel)
    {
        if (obj)
        {
            Object.assign(this, obj);
        }
    }

    public Id?: number | null;

    public Description?: string | null;

    /*
    
    public Active?: boolean | null;
    
    public SortOrder?: number | null;
    
    public CustomerOrderList?: number | null;
    */
   
    public RecCount?: number | null;
}

export { OrderStatusModel }
